import React, { useState,useRef,useCallback,useEffect } from 'react'
import { Button } from 'react-bootstrap';
import { lvl1_menu, lvl2_menu, lvl3_menu} from '../../../utils/checkType';
import { useDispatch, useSelector } from 'react-redux';
import { allFeatureTexture } from '../../../Actions/feature';
import _ from 'lodash';
import { paramsOfTextureAction } from '../../../Actions/paramsOfTextureAction';
import useGetData from '../../../hooks/useGetData';

const MenuTexture = () => {
    const [counter,setCounter] = useState(0);
    const [modelParent,setModelParent] = useState(0);
    const [state,setState] = useState({});
    const [pageNumber,setPageNumber] = useState(0);
    const [objId,setObjId] = useState();

    const {loading,error,data} = useGetData(pageNumber,objId);
    const picState = useSelector(state => state.picture);
    const textures = useSelector(state => state.texture);
    const dispatch = useDispatch();

    const observer = useRef();
    const lastTextureElenemtRef = useCallback(node => {
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                setObjId(entries[0].target.getAttribute("id"));
                setPageNumber(prevState => prevState + 1);
            }
        })
        if(node) observer.current.observe(node);
    },[]);


    const level_1 = lvl1_menu(textures);
    const level_2 = lvl2_menu(textures);
    const level_3 = lvl3_menu(textures);

    let object = {};
    if (counter === 0) {
        object = {...level_1};
    }else if(counter ===1) {
        object = state;
    }else if(counter ===2) {
        object = state;
    }
    
    const handleStageTexture = (id_obj,level) => {
        if (level === 1) {

            const a = _.filter(level_2.m, ['model_parent', id_obj]);//menu
            const b = _.filter(level_2.o, ['model_parent', id_obj]);//object
            const c = {m:a,o:b};
            setState({...c});
        }
        if (level === 2) {
            const a = _.filter(level_3.m, ['model_parent', id_obj]);//menu
            const b = _.filter(level_3.o, ['model_parent', id_obj]);//object
            const c = {m:a,o:b};
            setState({...c});
        }
    }
    
    const handleBackMenu = () => {
        if(modelParent === 1){
            setState({...level_1});
            if(counter > 0) setCounter(counter -1);
        }
        if(modelParent === 2){
            const a = _.filter(level_2.m, ['lvl', 2]);//menu
            // const b = _.filter(level_2.o, ['lvl', 2]);//object
            const b = [];//object
            const c = {m:a,o:b};
            setState({...c});
            if(counter > 0) setCounter(counter -1);
        }
    }
    useEffect(() => {
        if(object.o.length === 0){
            return;
        } else{
            object.o = _.uniq(object.o.concat(data));
        }
    }, [data]);
    return ( 
        <>
            <div className='back-menu w-100 my-1 pe-1'>
                <Button variant='none' style={{backgroundColor:'var(--themeColor)'}} className='w-100 text-light' onClick={handleBackMenu}>بازگشت</Button>
            </div>
            <div className='texture-container w-100' >
                {object.m.map((x,index) => (
                    <div key={index} className='texture-element' onClick={() => {
                        setCounter(counter + 1);
                        setModelParent(x.lvl);
                        handleStageTexture(x.object_id,x.lvl);
                    }}>
                        <article>
                            <img src={x.ticon} alt={x.name} className="img-texture"/>
                            <p className='p-2 texture-caption'>
                                {x.name}
                            </p>
                        </article>
                    </div>
                ))}
                {object.o.map((x,index) => {
                    if (object.o.length === index + 1) {
                        return <div key={x.procode} className='texture-element' id={x.object_id} ref={lastTextureElenemtRef}  onClick={() => {
                            dispatch(allFeatureTexture({featur_value:x.featur_value,translate:x.translate}))
                            dispatch(paramsOfTextureAction(x.object_id,x.procode))
                        }}>
                            <article>
                                <img src={x.ticon} alt={x.name} className="img-texture"/>
                                <p className='p-2 texture-caption'>
                                    {x.name}
                                </p>
                            </article>
                            <p className={picState.object_id === x.object_id ? "check-texture d-block" : "d-none"}><i className="fa fa-check"></i></p>
                        </div>
                    }else{
                        return <div className='texture-element' onClick={() => {
                            dispatch(allFeatureTexture({featur_value:x.featur_value,translate:x.translate}))
                            dispatch(paramsOfTextureAction(x.object_id,x.procode))
                        }}>
                            <article>
                                <img src={x.ticon} alt={x.name} className="img-texture"/>
                                <p className='p-2 texture-caption'>
                                    {x.name}
                                </p>
                            </article>
                            <p className={picState.object_id === x.object_id ? "check-texture d-block" : "d-none"}><i className="fa fa-check"></i></p>
                        </div>
                    }

                })}
                {/* {error && <h5>Error</h5>} */}
                {/* {loading && <h5>Loading</h5>} */}
                {/* <Button variant='light' onClick={() => setPageNumber(prevState => prevState + 1)}>Load more...</Button> */}
            </div>
        </>
    );
}
 
export default MenuTexture;